import React from 'react';
import { Card, Skeleton } from 'antd';
import SemanticPatternCard from '../../../components/semantic-pattern-card/SemanticPatternCard';

/**
 * A component to display the pattern cards
 */
const PatternList = React.memo(({ 
    patterns, 
    showPlaceholders, 
    onRemove, 
    form, 
    criteriaUpdating, 
    updateCriteriaFields, 
    onRegenerateAndProject,
    selectedPatternIds,
    onPatternSelectChange,
    filters = {}
}) => {
    // Apply filters to patterns
    const filteredPatterns = React.useMemo(() => {
        if (!patterns) return [];
        if (!filters.warningLevels && filters.hasConceptualLabel === null) return patterns;
        
        return patterns.filter(pattern => {
            // Filter by warning level (if specified)
            if (filters.warningLevels && filters.warningLevels.length > 0) {
                const warningLevel = form.getFieldValue(`warning-level-${pattern.id}`);
                if (!filters.warningLevels.includes(warningLevel)) {
                    return false;
                }
            }
            
            // Filter by presence/absence of conceptual labels (if specified)
            if (filters.hasConceptualLabel !== null) {
                const conceptualLabels = form.getFieldValue(`cl-${pattern.id}`) || [];
                const hasLabels = conceptualLabels.length > 0;
                if (hasLabels !== filters.hasConceptualLabel) {
                    return false;
                }
            }
            
            return true;
        });
    }, [patterns, filters, form]);
    
    if (showPlaceholders) {
        return (
            <div className="descriptions-masonry">
                {patterns?.map((_, index) => (
                    <Card key={index} loading={true} className='mb-16 f-width'>
                        <Skeleton active />
                    </Card>
                ))}
            </div>
        );
    }
    
    return (
        <div className="descriptions-masonry">
            {filteredPatterns.length === 0 ? (
                <div className="no-patterns-message" style={{ padding: '24px', textAlign: 'center' }}>
                    No patterns match the current filters
                </div>
            ) : (
                filteredPatterns.map(pattern => (
                    <SemanticPatternCard
                        key={pattern.id}
                        semanticPattern={pattern}
                        onRemove={onRemove}
                        form={form}
                        criteriaThatAreWaitingForRegenerate={criteriaUpdating}
                        setCriteriaFields={updateCriteriaFields}
                        onRegenerateAndProject={onRegenerateAndProject}
                        isSelected={selectedPatternIds.includes(pattern.id)}
                        onSelectChange={onPatternSelectChange}
                    />
                ))
            )}
        </div>
    );
});

export default PatternList; 